import { Column } from "./SheetCreate.styles";
import { Flex } from "../../../../../shared/base-components/Layouts/Flex/Flex.styles";
import { RuleEngineSheetColumn } from "./SheetCreate";
import { useEffect } from "react";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Divider, Form, Input, Radio, Select, Tooltip } from "antd";
import { DragOutlined } from "@ant-design/icons";

export const SheetColumn = ({ column }: { column: RuleEngineSheetColumn }) => {
  const [form] = Form.useForm();
  const type = Form.useWatch("columnType", form);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column.id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "move",
    ...(isDragging ? { position: "relative", zIndex: 9999 } : {}),
  };

  useEffect(() => {
    form.setFieldsValue(column);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="column-container">
      <Column
        style={style}
        className={isDragging ? "dragging column" : "column"}
      >
        <Flex>
          <h4 className="column-order">{column.columnOrder}</h4>
          <Tooltip title="Drag to reorder">
            <DragOutlined
              ref={setNodeRef}
              {...attributes}
              {...listeners}
              className="grab"
            />
          </Tooltip>
        </Flex>
        <Form form={form} layout="vertical" size="small">
          <Form.Item label="Heading 1" name="columnName">
            <Input />
          </Form.Item>
          <Form.Item label="Heading 2" name="helpText">
            <Input />
          </Form.Item>
          <Form.Item label="Type" name="columnType">
            <Radio.Group>
              <Flex flexDirection="column" alignItems="flex-start">
                <Radio value="input">Input</Radio>
                <Radio value="rowReference">Row Reference</Radio>
                <Radio value="columnReference">Column Reference</Radio>
                <Radio value="calculation">Calculation</Radio>
                <Radio value="diagnostics">Diagnostics</Radio>
              </Flex>
            </Radio.Group>
          </Form.Item>
          {(type === "rowReference" || type === "columnReference") && (
            <Form.Item label="Reference Data" name="referenceData">
              <Flex
                className="ant-input css-dev-only-do-not-override-1o3bmvh ant-input-outlined"
                padding="0"
              >
                <Select placeholder="Select Sheet" variant="borderless">
                  <Select.Option value="1">Sheet 1</Select.Option>
                  <Select.Option value="2">Sheet 2</Select.Option>
                </Select>
                <Divider type="vertical" />
                <Select placeholder="Select Column" variant="borderless">
                  <Select.Option value="1">Column 1</Select.Option>
                  <Select.Option value="2">Column 2</Select.Option>
                </Select>
              </Flex>
            </Form.Item>
          )}
          {type === "rowReference" && (
            <Form.Item label="Loop Order" name="loopOrder">
              <Radio.Group>
                <Radio value={1}>1</Radio>
                <Radio value={2}>2</Radio>
                <Radio value={3}>3</Radio>
                <Radio value={4}>4</Radio>
                <Radio value={5}>5</Radio>
              </Radio.Group>
            </Form.Item>
          )}
          {(type === "calculation" || type === "diagnostics") && (
            <Form.Item label={type.toPascalCase()} name="columnName">
              <Input />
            </Form.Item>
          )}
        </Form>
      </Column>
    </div>
  );
};
